import { makeStyles } from '@material-ui/core';

const styles = {
    container: {
        marginTop: '16px',
    },
};

export const useStyles = makeStyles(styles, { name: 'ListItem' });
